// extracted by mini-css-extract-plugin
export var reviewBox = "index-module--reviewBox--OqVuK";
export var reviewWrapper = "index-module--reviewWrapper--2Ebwb";
export var avatar = "index-module--avatar--10cl5";
export var text = "index-module--text--3LRH2";
export var border = "index-module--border--37ULX";
export var fill = "index-module--fill--PfcEi";